<nav
  [ngClass]="{ 'expanded-nav': expanded }"
  fxLayout="column"
  fxLayoutAlign="start start"
  *ngIf="isVisible()"
>
  <div class="nav-header" fxLayout="row">
    <button
      title="Menu"
      fxLayoutAlign="start start"
      fxFlex="none"
      mat-button
      class="nav-toggle-icon"
      (click)="toggleNav($event)"
    >
      <mat-icon inline="true">menu</mat-icon>
    </button>

    <div
      fxFlex="grow"
      class="welcome-container"
      fxLayoutAlign="start end"
      *ngIf="expanded"
    >
      <span>
        <p class="welcome-text">Welcome</p>
        <p class="name-text">
          {{ userName }}
        </p>
      </span>
    </div>

    <digital-platform-user-profile-dropdown
      title="Settings"
      fxLayoutAlign="end end"
      fxFlex="nogrow"
      class="user-profile-dropdown"
      variation="original"
      *ngIf="expanded"
    >
      <ng-container *ngIf="emailVerified$ | async"
        ><button
          title="Settings"
          mat-menu-item
          [routerLink]="'/profile-settings'"
        >
          Settings
        </button>
      </ng-container>
      <button
        title="How To Use The Hub"
        mat-menu-item
        [routerLink]="'/hub-user-guide'"
      >
        How To Use The Hub
      </button>
      <button
        title="Release Notes"
        mat-menu-item
        [routerLink]="'/release-notes'"
      >
        Release Notes
      </button>
    </digital-platform-user-profile-dropdown>
  </div>

  <hr class="divider" />

  <!-- Placeholder until comments are added -->
  <div class="comments" *ngIf="expanded"></div>
  <div *ngIf="expanded">
    <a
      mat-button
      title="Dashboard"
      *ngIf="isDashboardLinkVisible"
      [routerLink]="isCustomer ? '/dashboard' : '/search-waste-profile'"
      [routerLinkActive]="'active-link'"
      [routerLinkActiveOptions]="{ exact: true }"
      [hidden]="!expanded"
    >
      Dashboard
    </a>
    <a
      mat-button
      title="Services"
      [routerLink]="'/services'"
      [routerLinkActive]="'active-link'"
      *digitalPlatformPermission="'list:service'"
    >
      Services
    </a>
    <a
      mat-button
      title="Waste Profiles"
      [routerLink]="'/waste-profiles'"
      [routerLinkActive]="'active-link'"
      *digitalPlatformPermission="'list:waste_profile'"
    >
      Waste Profiles
    </a>
    <a
      mat-button
      title="Assets"
      [routerLink]="'/map'"
      [routerLinkActive]="'active-link'"
      *digitalPlatformPermission="'view:asset'"
    >
      Assets
    </a>
    <a
      mat-button
      title="Profile Status"
      [routerLink]="'/waste-profiles-status'"
      [routerLinkActive]="'active-link'"
      *digitalPlatformPermission="'update:waste_profile_status'"
      data-cy="profile-status"
    >
      Profile Status
    </a>
    <a
      mat-button
      title="Generator"
      [routerLink]="'/generators'"
      [routerLinkActive]="'active-link'"
      *digitalPlatformPermission="'list:generator'"
    >
      Generator
    </a>
    <a
      mat-button
      title="WP Admin"
      [routerLink]="'/search-waste-profile'"
      [routerLinkActive]="'active-link'"
      *digitalPlatformPermission="'search:waste_profile'"
    >
      WP Admin
    </a>
    <a
      mat-button
      title="Data Metrics"
      [routerLink]="'/data-metrics'"
      [routerLinkActive]="'active-link'"
      *digitalPlatformPermission="'view:metrics'"
    >
      Data Metrics
    </a>
    <a
      mat-button
      title="3rd Party Authorizations"
      [routerLink]="'/authorization-forms'"
      [routerLinkActive]="'active-link'"
      *digitalPlatformPermission="'list:3pa'"
    >
      3rd Party Authorizations
    </a>
    <a
      mat-button
      title="Reporting"
      [routerLink]="'/reporting-page'"
      [routerLinkActive]="'active-link'"
      *digitalPlatformPermission="'reporting:waste_profile'"
    >
      Reporting
    </a>
    <a
      mat-button
      title="Manifests"
      [routerLink]="'/manifests'"
      [routerLinkActive]="'active-link'"
      *digitalPlatformPermission="'view:manifest'"
    >
      Manifests
    </a>
    <a
      mat-button
      title="CSA"
      [routerLink]="'/service-agreements/summary'"
      [routerLinkActive]="'active-link'"
      *digitalPlatformPermission="'create:service_agreement'"
    >
      CSA
    </a>
  </div>
  <!-- </nav> -->

  <digital-platform-user-profile-dropdown
    fxLayoutAlign="center center"
    class="user-profile-dropdown-container"
    variation="side-nav"
    *ngIf="!expanded"
  >
    <ng-container *ngIf="emailVerified$ | async"
      ><button
        title="Settings"
        mat-menu-item
        [routerLink]="'/profile-settings'"
      >
        Settings
      </button>
    </ng-container>
    <button
      title=" How To Use The Hub"
      mat-menu-item
      [routerLink]="'/hub-user-guide'"
    >
      How To Use The Hub
    </button>
    <button title="Release Notes" mat-menu-item [routerLink]="'/release-notes'">
      Release Notes
    </button>
  </digital-platform-user-profile-dropdown>

  <!-- Placeholder until comments are added -->
</nav>
